import { c as _c } from "react/compiler-runtime";
import { Divider, FontWeights } from "@flat-ui";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Stack } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";

/** The clear all filter button and its functionality */
export function FilterToolbarClearAll() {
  const $ = _c(8);
  const {
    isAnyFilterApplied,
    clearAllFilters
  } = useFilterQueryParams();
  const tableType = useAppSelector(tableTypeSelector);
  if (!isAnyFilterApplied) {
    return null;
  }
  let t0;
  if ($[0] !== clearAllFilters || $[1] !== tableType) {
    t0 = function onClearClicked() {
      if (tableType !== null) {
        clearAllFilters(tableType);
      }
    };
    $[0] = clearAllFilters;
    $[1] = tableType;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onClearClicked = t0;
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: 1
    };
    t2 = <Divider orientation="vertical" flexItem={true} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontWeight: FontWeights.SemiBold
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClearClicked) {
    t4 = <Stack direction="row" sx={t1}>{t2}<FaroTextButton onClick={onClearClicked} tooltipText="Clear all filters" sx={t3}>Clear filters</FaroTextButton></Stack>;
    $[6] = onClearClicked;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}